import { render, staticRenderFns } from "./PackageListGenerator.vue?vue&type=template&id=0c28b8f0&scoped=true"
import script from "./PackageListGenerator.vue?vue&type=script&lang=js"
export * from "./PackageListGenerator.vue?vue&type=script&lang=js"
import style0 from "./PackageListGenerator.vue?vue&type=style&index=0&id=0c28b8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28b8f0",
  null
  
)

export default component.exports